
<div class="icon-wrapper" (click)="open(content)"><ng-content select="[action]"></ng-content><ng-content title></ng-content></div>

<ng-template #content let-modal>
  <div class="modal-header {{color}}">
    <div class="container-fluid">
      <div class="row modal-header-row">
        <img class="modal-icon" src={{iconSrc}} [ngClass]="iconClass" alt="icon">
        <span class="modal-title" id="modal-basic-title">{{title}}</span>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <div [innerHTML]="text"></div>
  </div>
  @if (!isQuestion) {
    <div class="modal-footer">
      <button type="button" class="btn modal-btn" (click)="modal.close('Save click')">OK</button>
    </div>
  }
  @if (isQuestion) {
    <div class="modal-footer">
      <button type="button" class="btn modal-btn" (click)="close()">DISAGREE</button>
      <button type="button" class="btn modal-btn" [disabled]="disableDeleteConfirmButton" (click)="confirm()">AGREE</button>
    </div>
  }
</ng-template>


